export const PAGE_ROUTE = {
  HOME: 'HOME',
  TEASING: 'TEASING',
  MARKETPLACE: 'MARKETPLACE',
  TENANT_PROFILE: 'TENANT_PROFILE',
  TENANT_ANUNT: 'TENANT_ANUNT',
  PUBLIC_PROFILE: 'PUBLIC_PROFILE',
  LANDLORD_PROFILE: 'LANDLORD_PROFILE',
  DASHBOARD: 'DASHBOARD',
  DASHBOARD_PROFIL: 'DASHBOARD_PROFIL',
  DASHBOARD_ANUNT: 'DASHBOARD_ANUNT',
  DASHBOARD_APLICARI: 'DASHBOARD_APLICARI',
  DASHBOARD_APLICARI_ARCHIVE: 'DASHBOARD_APLICARI_ARCHIVE',
  DASHBOARD_PROFILE_SALVATE: 'DASHBOARD_PROFILE_SALVATE',
  DASHBOARD_SETARI: 'DASHBOARD_SETARI',
  PROPERTY_EDITOR: 'PROPERTY_EDITOR',
  ONBOARDING: 'ONBOARDING',
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_TOKEN: 'RESET_PASSWORD_TOKEN',
  CONTACT: 'CONTACT',
  TERMENI: 'TERMENI',
  CONFIDENTIALITATE: 'CONFIDENTIALITATE',
  REVIEW_SUBMISSION: 'REVIEW_SUBMISSION',
  CHANGELOG: 'CHANGELOG',
  PRICING: 'PRICING',
} as const

export type PageRoute = (typeof PAGE_ROUTE)[keyof typeof PAGE_ROUTE]
